/**
 * Extracts the vertical identifier from an AI config object.
 * Parses the `applicationInformation.vertical` field (e.g., "AOT - Some VP")
 * and returns the normalized first segment (e.g., "aot").
 *
 * @param aiConfig - The parsed AI configuration YAML object
 * @returns The lowercase vertical identifier, or null if not available
 */
export function extractVerticalFromAIConfig(aiConfig: Record<string, unknown> | null): string | null {
  if (!aiConfig) return null;
  const appInfo = aiConfig.applicationInformation as Record<string, unknown> | undefined;
  const vertical = appInfo?.vertical as string | undefined;
  if (!vertical) return null;
  return vertical.split(' - ')[0].trim().toLowerCase();
}
